(function () {
    var anchors = document.querySelectorAll('[data-anchor]');

    if (anchors.length < 1)
        return false

    
    anchors[0].addEventListener('click', function () {
        var id = anchors[0].dataset.anchor;

        if (!id)
            return false

        var element = document.getElementById(id.replace('#', ''));

        if (element && element.scrollIntoView)
            element.scrollIntoView();
    });
})();